package com.tovtalk.domain.entity

/**
 * Content category (for consumption preferences and upload classification).
 */
data class Category(
    val id: Int,
    val name: String,
    val sortOrder: Int
)
